import { AnyObject } from 'yup';
import { SchemaDescription } from '../lib';

export const isSchemaDescription = <SchemaShape extends AnyObject>(value: unknown): value is SchemaDescription<SchemaShape> =>
    typeof (value as SchemaDescription<SchemaShape>).type !== 'undefined' &&
    typeof (value as SchemaDescription<SchemaShape>).optional !== 'undefined';
